/* eslint-disable no-unused-vars,jsx-a11y/anchor-has-content,jsx-a11y/href-no-hash */
import React, { useState } from 'react';
import { useLightForm } from 'utils/hooks/useLightForm';
import classNames from 'classnames';
import { t } from 'utils/translates';

import UserService from 'mt-react-common/modules/users/services/UserService';
import OpacityPreLoader from 'components/Common/PreLoaders/OpacityPreLoader';

import ChangePasswordApproveModal from './ChangePasswordApproveModal';

const UserChangePasswordForm = props => {
  const [showApproveModel, setShowApproveModal] = useState(false);

  const changePassword = useLightForm({
    current_password: null,
    new_password: null,
    confirm_password: null
  });

  const fetchChangePassword = () => {
    changePassword.setLoading(true);
    UserService.changePassword(null, changePassword.fields).then(
      responseModel => {
        if (responseModel && responseModel.status === 200) {
          changePassword.resetFields();
          setShowApproveModal(true);
        } else if (responseModel && responseModel.status === 422) {
          changePassword.setErrors(responseModel.data);
        }
        changePassword.setLoading(false);
      }
    );
  };

  const errorDesc = fieldName => {
    const errorMessage = changePassword.getFirstFieldError(fieldName);
    if (errorMessage) {
      return <small className="help-block">{errorMessage}</small>;
    }
    return null;
  };

  return (
    <div className="panel panel-default panel-heading_padding-large panel-body_bg-sub panel-footer_padding-large pos-rel">
      <ChangePasswordApproveModal
        isOpen={showApproveModel}
        onClose={() => setShowApproveModal(false)}
      />
      <div className="panel-heading text-center">
        <h2 className="panel-title">
          <i className="fa fa-lock" /> {t('Смена пароля')}
        </h2>
      </div>
      <form
        className="pos-rel ng-untouched ng-pristine ng-invalid"
        noValidate=""
        onSubmit={fetchChangePassword}
      >
        {changePassword.isLoading ? <OpacityPreLoader /> : null}
        <div className="panel-body">
          <div
            className={classNames('form-group', {
              'has-error': changePassword.hasFieldError('current_password')
            })}
          >
            <label className="control-label" htmlFor="passwordOld">
              {t('Старый пароль')}
            </label>
            <input
              className="form-control ng-untouched ng-pristine ng-invalid"
              id="passwordOld"
              minLength="6"
              name="passwordOld"
              placeholder={t('Старый пароль')}
              required=""
              type="password"
              value={changePassword.getFieldValue('current_password')}
              onChange={e => {
                changePassword.setFieldValue(
                  'current_password',
                  e.target.value
                );
              }}
            />
            {errorDesc('current_password')}
          </div>
          <div
            className={classNames('form-group', {
              'has-error': changePassword.hasFieldError('new_password')
            })}
          >
            <label className="control-label" htmlFor="passwordNew">
              {t('Новый пароль')}
            </label>
            <input
              className="form-control ng-untouched ng-pristine ng-invalid"
              id="passwordNew"
              minLength="6"
              name="passwordNew"
              placeholder={t('Новый пароль')}
              required=""
              type="password"
              value={changePassword.getFieldValue('new_password')}
              onChange={e => {
                changePassword.setFieldValue('new_password', e.target.value);
              }}
            />
            {errorDesc('new_password')}
          </div>
          <div
            className={classNames('form-group', {
              'has-error': changePassword.hasFieldError('confirm_password')
            })}
          >
            <label className="control-label" htmlFor="passwordConfirm">
              {t('Новый пароль еще раз')}
            </label>
            <input
              className="form-control ng-untouched ng-pristine ng-invalid"
              id="passwordConfirm"
              name="passwordConfirm"
              placeholder={t('Новый пароль еще раз')}
              required=""
              type="password"
              value={changePassword.getFieldValue('confirm_password')}
              onChange={e => {
                changePassword.setFieldValue(
                  'confirm_password',
                  e.target.value
                );
              }}
            />
            {errorDesc('confirm_password')}
          </div>
        </div>
        <div className="panel-footer">
          <div className="btn-toolbar">
            <a
              className="btn btn-primary"
              data-toggle="modal"
              onClick={e => {
                e.preventDefault();
                fetchChangePassword();
              }}
              href="#"
            >
              {t('Сохранить')}
            </a>
          </div>
        </div>
      </form>
    </div>
  );
};

UserChangePasswordForm.propTypes = {};

export default UserChangePasswordForm;



// WEBPACK FOOTER //
// ./src/components/UserAccount/UserChangePasswordForm/index.js